import { fromJS } from 'immutable';

import {
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_EUROPEAN_UNION_STATE,
  RESET_MEDICAL_EXPENSES_STATE,
  RESET_DENTAL_EXPENSES_STATE,
  RESET_FUNAREL_EXPENSES_STATE,
  RESET_HOSPITALISED_STATE,
  RESET_ACCOMPANYING_PERSON_HOSPITALISED_STATE,
  RESET_EXPENSES_ARISING_FROM_TERRORISM_STATE,
  RESET_MEDICAL_HOSPITAL_EXPENSES1_STATE,
  RESET_MEDICAL_HOSPITAL_EXPENSES2_STATE,
  RESET_MEDICAL_HOSPITAL_EXPENSES3_STATE,
  RESET_MEDICAL_HOSPITAL_EXPENSES4_STATE,
  RESET_MEDICAL_HOSPITAL_EXPENSES5_STATE,
  RESET_MEDICAL_HOSPITAL_EXPENSES6_STATE,
  RESET_MEDICAL_HOSPITAL_EXPENSES7_STATE,
  RESET_MEDICAL_HOSPITAL_EXPENSES8_STATE,
  RESET_MEDICAL_HOSPITAL_EXPENSES9_STATE,
  RESET_MEDICAL_HOSPITAL_EXPENSES10_STATE,
  RESET_MEDICAL_HOSPITAL_EXPENSES11_STATE,
  RESET_MEDICAL_HOSPITAL_EXPENSES12_STATE,
  RESET_MEDICAL_HOSPITAL_EXPENSES13_STATE,
  RESET_MEDICAL_HOSPITAL_EXPENSES14_STATE,
  RESET_THE_DEATH_CAUSED_BY_AN_INJURY_STATE,
} from './constants';

// The initial state of the App
const initialState = fromJS({
  form: {
    whatExpensesAreYouClaimingFor: [],
    whatAreYourExpensesRelatedTo: [],
    // Medical & Hospital Expenses
    infoMedicalExpensesItems: [],
    infoOpticalTreatmentItems: [],
    infoAncillaryServicesItems: [],
    infoMentalHealthItems: [],
    infoSexualHealthItems: [],
    infoExtraTravelAndAccommodationItems: [],
    infoSearchAndRescueItems: [],
    infoUrgentCareOutOfHoursVisitsItems: [],
    infoPrescriptionsItems: [],
    infoGPVisitsItems: [],

    infoRehabilitationAndOccupationalTherapyItems: [],
    infoMaternityCareItems: [],
    infoReplacementStaffItems: [],
    infoRepatriationBenefitItems: [],

    infoOtherMedicalExpensesItems: [],
    wereYouHospitalisedForMoreThanThreeDays: '',
    wereYouHospitalisedForMoreThanTenDays: '',
    admissionDate: '',
    dischargeDate: '',
    infoMedicalExpensesHospitalisedItems: [],
    didAnAccompanyingPersonTravelFromYourHomeCountryWhilstYouWereHospitalised: '',
    infoMedicalExpensesCompanionItems: [],
    // Dental Expenses
    infoDentalExpensesItems: [],
    // Funeral Expenses
    infoFuneralExpensesItems: [],
    wasTheDeathCausedByAnInjury: '',
    infoTheDeathCausedByAnInjuryItems: [],
    // Expenses arising from terrorism
    infoExpensesArisingFromTerrorismItems: [],
  },
  errors: [],
});

const initialMedicalExpenses = {
  form: {
    whatAreYourExpensesRelatedTo: [],
    infoMedicalExpensesItems: [],
    infoOpticalTreatmentItems: [],
    infoAncillaryServicesItems: [],
    infoMentalHealthItems: [],
    infoSexualHealthItems: [],
    infoExtraTravelAndAccommodationItems: [],
    infoSearchAndRescueItems: [],
    infoUrgentCareOutOfHoursVisitsItems: [],
    infoPrescriptionsItems: [],
    infoGPVisitsItems: [],
    infoRehabilitationAndOccupationalTherapyItems: [],
    infoMaternityCareItems: [],
    infoReplacementStaffItems: [],
    infoRepatriationBenefitItems: [],
    infoOtherMedicalExpensesItems: [],
    wereYouHospitalisedForMoreThanThreeDays: '',
    admissionDate: '',
    dischargeDate: '',
    infoMedicalExpensesHospitalisedItems: [],
    didAnAccompanyingPersonTravelFromYourHomeCountryWhilstYouWereHospitalised: '',
    infoMedicalExpensesCompanionItems: [],
    wereYouHospitalisedForMoreThanTenDays: '',
  },
};

const initialDentalExpenses = {
  form: {
    infoDentalExpensesItems: [],
  },
};

const initialFuneralExpenses = {
  form: {
    infoFuneralExpensesItems: [],
    wasTheDeathCausedByAnInjury: '',
    infoTheDeathCausedByAnInjuryItems: [],
  },
};

const initialTheDeathCausedByAnInjury = {
  form: {
    infoTheDeathCausedByAnInjuryItems: [],
  },
};

const initialHospitalised = {
  form: {
    admissionDate: '',
    dischargeDate: '',
    infoMedicalExpensesHospitalisedItems: [],
    didAnAccompanyingPersonTravelFromYourHomeCountryWhilstYouWereHospitalised: '',
    infoMedicalExpensesCompanionItems: [],
  },
};

const initialAccompanyingPersonHospitalised = {
  form: {
    infoMedicalExpensesCompanionItems: [],
  },
};

const initialExpensesArisingFromTerrorism = {
  form: {
    infoExpensesArisingFromTerrorismItems: [],
  },
};

const initialOpticalTreatment = {
  form: {
    infoOpticalTreatmentItems: [],
  },
};

const initialAncillaryServices = {
  form: {
    infoAncillaryServicesItems: [],
  },
};

const initialMentalHealth = {
  form: {
    infoMentalHealthItems: [],
  },
};

const initialSexualHealth = {
  form: {
    infoSexualHealthItems: [],
  },
};

const initialExtraTravelAndAccommodation = {
  form: {
    infoExtraTravelAndAccommodationItems: [],
  },
};

const initialSearchAndRescue = {
  form: {
    infoSearchAndRescueItems: [],
  },
};

const initialUrgentCareOutOfHoursvisits = {
  form: {
    infoUrgentCareOutOfHoursVisitsItems: [],
  },
};

const initialPrescriptions = {
  form: {
    infoPrescriptionsItems: [],
  },
};

const initialGPVisits = {
  form: {
    infoGPVisitsItems: [],
  },
};

const initialOtherMedicalExpenses = {
  form: {
    infoOtherMedicalExpensesItems: [],
    wereYouHospitalisedForMoreThanThreeDays: '',
    admissionDate: '',
    dischargeDate: '',
    infoMedicalExpensesHospitalisedItems: [],
    didAnAccompanyingPersonTravelFromYourHomeCountryWhilstYouWereHospitalised: '',
    infoMedicalExpensesCompanionItems: [],
    wereYouHospitalisedForMoreThanTenDays: '',
  },
};

const initialRehabilitationAndOccupationalTherapy = {
  form: {
    infoRehabilitationAndOccupationalTherapyItems: [],
  },
};
const initialMaternityCare = {
  form: {
    infoMaternityCareItems: [],
  },
};
const initialReplacementStaff = {
  form: {
    infoReplacementStaffItems: [],
  },
};
const initialRepatriationBenefit = {
  form: {
    infoRepatriationBenefitItems: [],
  },
};

function medicalAndEvacuationSCTIStepReducer(state = initialState, action) {
  const properties = action.propertyName ? action.propertyName.split('.') : '';
  switch (action.type) {
    case VALUE_CHANGED:
      return state.setIn(properties, action.value);
    case LOAD:
      return action.payload
        ? fromJS({ form: action.payload, errors: [] })
        : initialState;
    case NEXT:
      return state.merge({ errors: action.errors });
    case RESET:
      return initialState;
    case RESET_MEDICAL_EXPENSES_STATE:
      return state
        .setIn(['form', 'whatAreYourExpensesRelatedTo'], [])
        .setIn(['form', 'infoMedicalExpensesItems'], [])
        .setIn(['form', 'infoOpticalTreatmentItems'], [])
        .setIn(['form', 'infoAncillaryServicesItems'], [])
        .setIn(['form', 'infoMentalHealthItems'], [])
        .setIn(['form', 'infoSexualHealthItems'], [])
        .setIn(['form', 'infoExtraTravelAndAccommodationItems'], [])
        .setIn(['form', 'infoSearchAndRescueItems'], [])
        .setIn(['form', 'infoUrgentCareOutOfHoursVisitsItems'], [])
        .setIn(['form', 'infoPrescriptionsItems'], [])
        .setIn(['form', 'infoGPVisitsItems'], [])
        .setIn(['form', 'infoRehabilitationAndOccupationalTherapyItems'], [])
        .setIn(['form', 'infoMaternityCareItems'], [])
        .setIn(['form', 'infoReplacementStaffItems'], [])
        .setIn(['form', 'infoRepatriationBenefitItems'], [])
        .setIn(['form', 'infoOtherMedicalExpensesItems'], [])
        .setIn(['form', 'infoMedicalExpensesHospitalisedItems'], [])
        .setIn(['form', 'infoMedicalExpensesCompanionItems'], [])
        .mergeDeep(initialMedicalExpenses);
    case RESET_DENTAL_EXPENSES_STATE:
      return state
        .setIn(['form', 'infoDentalExpensesItems'], [])
        .mergeDeep(initialDentalExpenses);
    case RESET_FUNAREL_EXPENSES_STATE:
      return state
        .setIn(['form', 'infoFuneralExpensesItems'], [])
        .setIn(['form', 'infoTheDeathCausedByAnInjuryItems'], [])
        .mergeDeep(initialFuneralExpenses);
    case RESET_HOSPITALISED_STATE:
      return state
        .setIn(['form', 'infoMedicalExpensesHospitalisedItems'], [])
        .setIn(['form', 'infoMedicalExpensesCompanionItems'], [])
        .mergeDeep(initialHospitalised);
    case RESET_ACCOMPANYING_PERSON_HOSPITALISED_STATE:
      return state
        .setIn(['form', 'infoMedicalExpensesCompanionItems'], [])
        .mergeDeep(initialAccompanyingPersonHospitalised);
    case RESET_EXPENSES_ARISING_FROM_TERRORISM_STATE:
      return state
        .setIn(['form', 'infoExpensesArisingFromTerrorismItems'], [])
        .mergeDeep(initialExpensesArisingFromTerrorism);

    case RESET_MEDICAL_HOSPITAL_EXPENSES1_STATE:
      return state
        .setIn(['form', 'infoOpticalTreatmentItems'], [])
        .mergeDeep(initialOpticalTreatment);

    case RESET_MEDICAL_HOSPITAL_EXPENSES2_STATE:
      return state
        .setIn(['form', 'infoAncillaryServicesItems'], [])
        .mergeDeep(initialAncillaryServices);
    case RESET_MEDICAL_HOSPITAL_EXPENSES3_STATE:
      return state
        .setIn(['form', 'infoMentalHealthItems'], [])
        .mergeDeep(initialMentalHealth);
    case RESET_MEDICAL_HOSPITAL_EXPENSES4_STATE:
      return state
        .setIn(['form', 'infoSexualHealthItems'], [])
        .mergeDeep(initialSexualHealth);
    case RESET_MEDICAL_HOSPITAL_EXPENSES5_STATE:
      return state
        .setIn(['form', 'infoExtraTravelAndAccommodationItems'], [])
        .mergeDeep(initialExtraTravelAndAccommodation);
    case RESET_MEDICAL_HOSPITAL_EXPENSES6_STATE:
      return state
        .setIn(['form', 'infoSearchAndRescueItems'], [])
        .mergeDeep(initialSearchAndRescue);
    case RESET_MEDICAL_HOSPITAL_EXPENSES7_STATE:
      return state
        .setIn(['form', 'infoUrgentCareOutOfHoursVisitsItems'], [])
        .mergeDeep(initialUrgentCareOutOfHoursvisits);
    case RESET_MEDICAL_HOSPITAL_EXPENSES8_STATE:
      return state
        .setIn(['form', 'infoPrescriptionsItems'], [])
        .mergeDeep(initialPrescriptions);
    case RESET_MEDICAL_HOSPITAL_EXPENSES9_STATE:
      return state
        .setIn(['form', 'infoGPVisitsItems'], [])
        .mergeDeep(initialGPVisits);
    case RESET_MEDICAL_HOSPITAL_EXPENSES10_STATE:
      return state
        .setIn(['form', 'infoOtherMedicalExpensesItems'], [])
        .setIn(['form', 'infoMedicalExpensesHospitalisedItems'], [])
        .setIn(['form', 'infoMedicalExpensesCompanionItems'], [])
        .mergeDeep(initialOtherMedicalExpenses);
    case RESET_MEDICAL_HOSPITAL_EXPENSES11_STATE:
      return state
        .setIn(['form', 'infoRehabilitationAndOccupationalTherapyItems'], [])
        .mergeDeep(initialRehabilitationAndOccupationalTherapy);
    case RESET_MEDICAL_HOSPITAL_EXPENSES12_STATE:
      return state
        .setIn(['form', 'infoMaternityCareItems'], [])
        .mergeDeep(initialMaternityCare);
    case RESET_MEDICAL_HOSPITAL_EXPENSES13_STATE:
      return state
        .setIn(['form', 'infoReplacementStaffItems'], [])
        .mergeDeep(initialReplacementStaff);
    case RESET_MEDICAL_HOSPITAL_EXPENSES14_STATE:
      return state
        .setIn(['form', 'infoRepatriationBenefitItems'], [])
        .mergeDeep(initialRepatriationBenefit);
    case RESET_THE_DEATH_CAUSED_BY_AN_INJURY_STATE:
      return state
        .setIn(['form', 'infoTheDeathCausedByAnInjuryItems'], [])
        .mergeDeep(initialTheDeathCausedByAnInjury);
    default:
      return state;
  }
}

export default medicalAndEvacuationSCTIStepReducer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.SCTI.MedicalAndEvacuation/reducer.js